import { useCallback, useEffect, useState } from "react";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getSimCardData } from "src/core/api/services/dms/sim-card.service";
import SimCardTableComponent from "./sim-card-table.component";
import { useSelector } from "react-redux";

const SimCardComponent = () => {
  const [PageNumber, setPageNumber] = useState<number>(1);
  const [simOrDeviceSearchValue, setSimOrDeviceSearchValue] = useState("");
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("serialNumber"));
  const [SortDirection, setSortDirection] = useState<any>("desc");
  const [filters, setFilters] = useState<any>({});

  const [columns, setColumns] = useState([
    {
      title: "SIM Card Serial No.",
      label: "serialNumber",
      isSorted: true,
    },
    {
      title: "Device ID",
      label: "deviceCode",
    },
    {
      title: "Block",
      label: "displayName",
    },
    {
      title: "Display Block",
      label: "blockName",
    },
  ]);

  const filter = useSelector((state: any) => {
    return state.simCard.filter;
  });

  useEffect(() => {
    setPageNumber(1);
    setFilters(filter);
  }, [filter]);

  const {
    data: simCardData,
    isLoading: isLoadingSimCardData,
    refetch,
  } = useQuery({
    queryKey: [
      "getSimCardData",
      PageNumber,
      SortBy,
      SortDirection,
      simOrDeviceSearchValue,
    ],
    queryFn: ({ signal }) =>
      getSimCardData(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        filters?.townCouncil,
        filters?.site,
        filters?.block,
        simOrDeviceSearchValue,
        signal,
      ),
  });

  const onRefetchData = () => {
    if (simCardData?.numberOfRecords <= pageSize + 1) {
      setPageNumber(1);
    }

    void refetch();
  };

  useEffect(() => {
    onRefetchData();
  }, [filters]);

  const handleChangePage = useCallback((page: number): void => {
    setPageNumber(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNumber(1);
    setSimOrDeviceSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    [],
  );

  return (
    <div>
      <SimCardTableComponent
        columns={columns}
        data={simCardData?.data}
        totalNumberOfRecords={simCardData?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingSimCardData}
        onSearch={handleSearch}
        filter={filter}
      />
    </div>
  );
};

export default SimCardComponent;
